import {createAction, props} from '@ngrx/store';
import {WxlOnboardAPIError} from '@app/shared/models/error.model';

/** Throw new Error */
export const newError = createAction('[Error] Throw New Back End Error', props<{backEndError: WxlOnboardAPIError}>());

export const removeError = createAction('[Error] Remove Back End Error by Index', props<{index: number}>());
